var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderPersonBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1098,
    viewBox: "0 0 856 1098",
    width: 856,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#101010",
    height: 146,
    rx: 8,
    width: 40,
    x: 0.02,
    y: 795.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#3deeb7",
    height: 146,
    rx: 8,
    width: 40,
    x: 135.02,
    y: 564.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#3deeb7",
    height: 146,
    rx: 8,
    width: 40,
    x: 680.02,
    y: 462.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#101010",
    height: 146,
    rx: 8,
    width: 40,
    x: 815.02,
    y: 608.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#3deeb7",
    height: 65,
    rx: 8,
    width: 40,
    x: 815.02,
    y: 797.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#101010",
    height: 146,
    rx: 8,
    width: 40,
    x: 680.02,
    y: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#3deeb7",
    height: 146,
    rx: 8,
    width: 40,
    x: 135.02,
    y: 110.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#3deeb7",
    height: 65,
    rx: 8,
    width: 40,
    x: 0.02,
    y: 693.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#101010",
    height: 65,
    rx: 8,
    width: 40,
    x: 135.02,
    y: 462.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#3deeb7",
    height: 65,
    rx: 8,
    width: 40,
    x: 680.02,
    y: 649.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#3deeb7",
    height: 65,
    rx: 8,
    width: 40,
    x: 270.02,
    y: 564.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#101010",
    height: 146,
    rx: 8,
    width: 40,
    x: 0.02,
    y: 381.18
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderPersonBg);
export default __webpack_public_path__ + "static/media/header-person_bg.4d32edad80a270d188f80afa95977f58.svg";
export { ForwardRef as ReactComponent };